@if (isUserRetrieved && isPwToChange) {
  <user-change-password [user] = "user" (onChangePassword)="onChangePassword()"></user-change-password>
}
<!-- Bestaetigung offener Mandanten laeuft jetzt als Dialog (siehe maybeOpenProfileDialog()
     in der .ts), nicht mehr als eingebettete Seite hier. -->
@if (!isPwToChange && isConfirmed) {
  <select-tenant></select-tenant>
}
@if (!isPwToChange && isNoTenantAssigned) {
  <div>
    <br><br>
    <span style="padding-left:20px"><b>Kein Mandant und keine Projekte mehr zugeordnet!</b></span>
  </div>
}

